<template>
  <div>
    <b-tabs
      v-if="canShowImageTab && canShowTemplateTab"
      ref="trackingSettingTabBar"
      v-model="innerTab"
      lazy
    >
      <b-tab>
        <template #title>
          <span>Update Tracking Page Image</span>
        </template>
        <TrackImage />
      </b-tab>
      <b-tab>
        <template #title>
          <span>Template Management</span>
        </template>
        <TrackingPageTemplateList
          v-if="mode === 'list'"
          @create="onCreateTemplate"
          @view="onViewTemplate"
        />
        <TrackingPageTemplateForm
          v-else
          :mode="mode"
          :template-id="selectedTemplateId"
          @back="onBackToList"
        />
      </b-tab>
    </b-tabs>
    <TrackImage v-else-if="canShowImageTab && mode === 'list'" />
    <TrackingPageTemplateList
      v-else-if="canShowTemplateTab && mode === 'list'"
      @create="onCreateTemplate"
      @view="onViewTemplate"
    />
    <TrackingPageTemplateForm
      v-else-if="mode !== 'list'"
      :mode="mode"
      :template-id="selectedTemplateId"
      @back="onBackToList"
    />
  </div>
</template>

<script>
import {
  BTabs, BTab,
} from 'bootstrap-vue'
import store from '@/store'
import TrackImage from '@/components/setting/TrackImage.vue'
import TrackingPageTemplateList from '@/components/setting/tracking-page/TrackingPageTemplateList.vue'
import TrackingPageTemplateForm from '@/components/setting/tracking-page/TrackingPageTemplateForm.vue'

export default {
  name: 'TrackingSettings',
  components: {
    BTabs,
    BTab,
    TrackImage,
    TrackingPageTemplateList,
    TrackingPageTemplateForm,
  },
  data() {
    return {
      innerTab: 0,
      mode: 'list',
      selectedTemplateId: null,
    }
  },
  computed: {
    canShowImageTab() {
      return store.getters.permissions.filter(permission => permission === 'tracking-page-image' || permission === 'show-edit-additional-tracking-details').length > 0
    },
    canShowTemplateTab() {
      return store.getters.permissions.filter(permission => permission === 'view-tracking-templates' || permission === 'create-tracking-templates' || permission === 'assign-merchants-to-tracking-template').length > 0
    },
  },
  methods: {
    onCreateTemplate() {
      this.innerTab = 1
      this.selectedTemplateId = null
      this.mode = 'create'
    },
    onViewTemplate(id) {
      this.innerTab = 1
      this.selectedTemplateId = id
      this.mode = 'view'
    },
    onBackToList() {
      this.innerTab = 1
      this.mode = 'list'
      this.selectedTemplateId = null
    },
  },
}
</script>
